<div class="review-order-files__wrapper" *ngIf="data != null" data-tour-anchor="review-order-design-simulation">
  <div
    class="review-order-files__body"
    [ngClass]="{
      'review-order-files__body--image': data.renderer === FileRenderer.image,
    }"
  >
    @if (data.renderer === FileRenderer.threedViewer) {
      <wl-threed-viewer
        [mode]="ThreedViewerMode.auto"
        [treatmentType]="data.productType"
        [colorConfig]="colorConfig"
        [files]="data.files"
        [archType]="data.archType"
      />
    }

    @if (data.renderer === FileRenderer.image) {
      <div class="review-order-files__preview review-order-files__preview--image">
        @if (isImageLoading || (linksDictionary[data.files[0].id] && !isImageLoaded && !isImageLoadFailed)) {
          <div class="review-order-files__preview__loading">
            <wl-spinner size="48px" />
            <span>{{ 'general.loading' | translate }}</span>
          </div>
        }

        @if (isImageLoadFailed) {
          <div class="review-order-files__preview__error">
            <span>{{ 'general.somethingWentWrong' | translate }}</span>
          </div>
        }

        @if (linksDictionary[data.files[0].id]; as imageUrl) {
          <img
            [src]="imageUrl"
            alt=""
            [class.review-order-files__preview__image--hidden]="!isImageLoaded || isImageLoadFailed"
            (load)="onImageLoaded()"
            (error)="onImageLoadError()"
          />
        }
      </div>
    }

    @if (data.renderer === FileRenderer.video) {
      <ng-container *ngIf="linksDictionary[data.files[0].id] as videoUrl">
        <div class="review-order-files__preview review-order-files__preview--video">
          <video [src]="videoUrl" controls></video>
        </div>
      </ng-container>
    }

    @if (data.renderer === FileRenderer.pdf) {
      <ng-container *ngIf="linksDictionary[data.files[0].id] as pdfUrl">
        <iframe
          class="review-order-files__preview review-order-files__preview--iframe"
          [src]="pdfUrl + '#toolbar=0' | safe: 'resourceUrl'"
        ></iframe>
      </ng-container>
    }

    @if (data.renderer === FileRenderer.sdsplink) {
      <ng-container *ngIf="textContentDictionary[data.files[0].id] as sdsplinkUrl">
        <iframe
          class="review-order-files__preview review-order-files__preview--iframe"
          [src]="sdsplinkUrl | safe: 'resourceUrl'"
        ></iframe>
      </ng-container>
    }
  </div>

  <div class="review-order-files__sidebar">
    <div class="review-order-files__sidebar__basic__wrapper">
      <span class="review-order-files__sidebar__basic__name">{{ data.order.patient }}</span>
      <span class="review-order-files__sidebar__basic__files">
        {{ data.files.length }}&nbsp;{{ 'general.files' | translate }}
      </span>
      <span class="review-order-files__sidebar__basic__date">
        {{ data.messageCreatedAt | date: 'MMM d, y' }}
      </span>
    </div>

    <div class="review-order-files__sidebar__advance__wrapper">
      @if (advanceDataChunks.length > 0) {
        <div *ngFor="let chunk of advanceDataChunks" class="review-order-files__sidebar__advance__chunk">
          <span class="review-order-files__sidebar__advance__chunk__label">
            {{ chunk.label | translate }}
          </span>
          <span class="review-order-files__sidebar__advance__chunk__value">
            {{ chunk.value | translateValue }}
          </span>
        </div>
      }
    </div>

    <div
      *ngIf="data.showApproveButton || data.showRequestRevisionButton"
      class="review-order-files__sidebar__actions__wrapper"
    >
      <p-button
        *ngIf="data.showApproveButton"
        severity="primary"
        data-tour-anchor="review-order-design-simulation-approve-and-pay"
        [disabled]="isApproving || disabled"
        [label]="
          data.showApproveAndPay === true ? ('general.approveAndPay' | translate) : ('general.approve' | translate)
        "
        [loading]="isApproving"
        (onClick)="onApprove()"
      />

      <p-button
        *ngIf="data.showRequestRevisionButton"
        severity="secondary"
        [label]="'general.requestRevision' | translate"
        (onClick)="onRequestRevision()"
      />
    </div>
  </div>

  <div class="modal-custom-close">
    <p-button icon="pi pi-times" severity="secondary" (onClick)="onClose()" [text]="true" />
  </div>
</div>
